import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Card, DatePicker, Form, Input, Row, Col, Popover } from 'antd';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
// import regIcon from 'assets/images/register-icon.svg';
import { ActionType, RegistrationFlowContext } from 'contexts/registration';
import { RegistrationFormData } from 'contexts/registration/registrationFormData';
// import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { disabledDate } from 'utils';
// import { IconTitle } from 'components';
import { useLifePolicyValidate } from 'all-in-one-shared-api';
import PolicyAndMemberIdModal from '../forget/PolicyAndMemberIdModal';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { revalidateAntdFormLanguageChanged } from '../../i18n';
// import { StyledTitle } from 'components/StyledTitle';
import moment from 'moment';
import { Typography } from 'antd';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { useKeycloak } from 'all-in-one-react-keycloak';
import './LifeConnect.less';
import { NamePath } from 'rc-field-form/es/interface';
import tanhao from 'assets/images/MakeRequest/tanhao.svg';

// import _get from 'lodash/get';
// import moment from 'moment';
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  padding-left: 200px;
  padding-right: 200px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
const FormWrapper = styled.div`
  display: grid;
  row-gap: 12px;
  width: 550px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

function ProfileConnectLife() {
  const [errmessage, setErrmessage] = useState<string | null>(null);
  // const [ApiError, setApiError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  // const initialValues = useRegistrationStateQuery();
  const [registrationState, setRegistrationState] = useState<RegistrationFormData>({});
  const { dispatch } = useContext(RegistrationFlowContext);
  // const [mobilePrefix, setMobilePrefix] = useState(initialValues.countryCode || defaultPrefix);
  const navigate = useNavigate();
  // const dateFormat = DEFAULT_DATE_FORMAT;
  // const [snackbarMessage, setSnackbarMessage] = useState(initialValues.registerError || '');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  // const emailRef = React.useRef<InputRef>(null);

  const [form] = Form.useForm();
  const [randoms, setRandoms] = useState(0);
  const { keycloak } = useKeycloak();
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [form, i18n.language]);

  const {
    shouldFetch: shouldFetch,
    data: data,
    error: error,
    isLoading,
  } = useLifePolicyValidate(
    'useLifePolicyValidate' + randoms,
    keycloak.token as string,
    registrationState.identityNo ?? '',
    registrationState.dob ? moment(registrationState.dob).format('DD/MM/YYYY') : '',
  );
  const isValid = registrationState.identityNo?.trim() !== '' && registrationState.dob;
  console.log(registrationState.identityNo, registrationState.dob);
  const [errorCode, setErrorCode] = useState('');
  /* eslint-disable */
  useEffect(() => {
    if (data && !error) {
      //   setLoading(false);

      console.log('data', data);
      // 更新上下文
      // dispatch({
      //   type: ActionType.UpdateFormData,
      //   payload: { countryCode, email, mobile },
      // });
      // if (mobile || email) {
      //   navigate('/register/LifeRegistrationSubmission', { replace: true });
      // }
      navigate('/connectLifeOtp', {
        state: {
          countryCode: data.countryCode,
          email: data.email,
          mobile: data.mobile,
          identityNo: registrationState.identityNo ? registrationState.identityNo : '',
          birthDate: registrationState.dob ? moment(registrationState.dob).format('DD/MM/YYYY') : '',
          areaCode: data.areaCode ?? '',
        },
      });
    } else if (error && error.code) {
      shouldFetch(false);
      //   setLoading(false);
      setErrorCode(error.code);
      const errorMessage = setErrorCodeFun(error.code, i18n.language);
      console.log('error', error);
      setErrmessage(errorMessage);
    }
  }, [data, error]); // 监听 data 变化
  /* eslint-enable */
  useEffect(() => {
    setRandoms(Math.random());
    return () => {
      shouldFetch(false);
    };
  }, [shouldFetch]);
  const onValidateSuccessful = React.useCallback(
    (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {
      setRandoms(Math.random());
      shouldFetch(true);
      event && event.preventDefault();
      dispatch({ type: ActionType.UpdateFormData, payload: data });
    },
    [shouldFetch, dispatch],
  );
  /* eslint-disable */
  useEffect(() => {
    let name: NamePath[] | undefined = [];
    form.getFieldsError().forEach((d) => {
      if (d.errors.length && d.name) {
        name = name?.concat(d.name);
      }
    });
    console.log(form.getFieldsError(), 'form.getFieldsError()');

    if (form.getFieldsError().some((errors) => errors.errors.length)) {
      form.validateFields(name);
    }
    if (errorCode && errmessage) {
      const errorMessage = setErrorCodeFun(errorCode, i18n.language);
      console.log('error', error);
      setErrmessage(errorMessage);
    }
  }, [i18n.language]);
  const onFinish = (values: RegistrationFormData) => {
    // dispatch({ type: ActionType.UpdateFormData, payload: values }); //提交时注释掉
    // navigate('/register/LifeRegistrationSubmission'); //提交时注释掉
    setRegistrationState({
      identityNo: values.identityNo,
      dob: values.dob,
    });
    if (registrationState.identityNo && registrationState.dob) {
      onValidateSuccessful(registrationState);
    }
  };
  useEffect(() => {
    if (registrationState.identityNo && registrationState.dob) {
      // onValidateSuccessful(registrationState);
    }
  }, [registrationState, onValidateSuccessful]);
  // const handleChange = (value: string) => {
  //   setMobilePrefix(value);
  // };
  const closeModel = () => {
    setIsModalVisible(false);
  };

  // const prefixSelector = <MobileNumberPrefix handleChange={handleChange} />;
  // const infoIcon = <InfoCircleOutlined style={{ cursor: 'pointer' }} onClick={showModal} />;

  return (
    // <div
    //   style={{
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'flex-start',
    //     justifyContent: 'center',
    //     backgroundColor: 'transparent',
    //   }}
    // >
    <ResponsiveContainer>
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <Wrapper className="life_connect_wrapper" style={{ backgroundColor: 'white', borderRadius: 0, border: 0 }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]} style={{ backgroundColor: 'white' }}>
            <Form
              // initialValues={initialValues}
              layout={'vertical'}
              requiredMark={false}
              onFinish={onFinish}
              form={form}
              validateTrigger={'onBlur'}
              style={{ width: '100%' }}
            >
              <FormWrapper>
                <Col
                  xs={24}
                  md={24}
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}
                >
                  <Typography.Text
                    style={{ margin: '0 0 24px 0', fontSize: '26px', fontFamily: 'Roboto400', color: '#20252B' }}
                  >
                    {t('registration.lifeInsuranceTitle')}
                  </Typography.Text>
                  {/* <Divider /> */}
                </Col>
                <Col xs={24} md={24}>
                  <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                    {t('registration.lifemessage')}
                  </Typography.Text>
                </Col>
                <Col xs={24} md={24}>
                  <Typography.Text style={{ color: '#752127', fontSize: '17px', fontFamily: 'Roboto400' }}>
                    {t('forgetPassword.mandatoryMsg')}
                  </Typography.Text>
                </Col>

                <Col xs={24} md={24} style={{ position: 'relative' }}>
                  <BoldLabelFormItem
                    label={
                      <div
                        className="CreditCardNumber"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span
                          style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                        >
                          {t('registration.idOrPassport')}
                        </span>
                      </div>
                    }
                    name="identityNo"
                    rules={[{ required: true, message: t('registration.error.required') }]}
                    // tooltip={{ icon: infoIcon }}
                  >
                    <Input
                      size="middle"
                      onChange={(e) => {
                        setRegistrationState({
                          ...registrationState,
                          identityNo: e.target.value,
                        });
                      }}
                      // disabled={initialValues.isEmailRegister}
                      placeholder={t('registration.policyNumberHolder')}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                    />
                  </BoldLabelFormItem>
                  <div style={{ position: 'absolute', top: 0, right: 16 }}>
                    <Popover
                      placement="topLeft"
                      content={
                        <div style={{ width: '350px' }}>
                          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072', margin: 0 }}>
                            {t('life.forgetLoginId.IdFormats')}
                          </p>
                          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
                            {t('life.forgetLoginId.HKID')}
                          </p>
                          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
                            {t('life.forgetLoginId.HKID2')}
                          </p>
                        </div>
                      }
                    >
                      <img src={tanhao} style={{ margin: '0  2px 0 10px', width: '20px', height: '20px' }} />
                    </Popover>
                  </div>
                </Col>
                {/* <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('life.forgetLoginId.memberId')}
                      </span>
                    }
                    name="memberId"
                    rules={[{ required: true, message: t('registration.error.required') }]}
                    // tooltip={{ icon: infoIcon }}
                  >
                    <Input
                      maxLength={12}
                      size="middle"
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                      placeholder={t('life.forgetLoginId.enterMemberId')}
                      // onKeyPress={(event) => {
                      //   if (!/[0-9a-zA-Z]/.test(event.key)) {
                      //     event.preventDefault();
                      //   }
                      // }}
                    />
                  </BoldLabelFormItem>
                </Col> */}
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('registration.dobLabel')}*
                      </span>
                    }
                    name="dob"
                    rules={[{ required: true, message: t('registration.error.required') }]}
                  >
                    <DatePicker
                      disabledDate={disabledDate}
                      placeholder={t('common.placeholder.date')}
                      format="DD/MM/YYYY"
                      onChange={(e) =>
                        setRegistrationState({
                          ...registrationState,
                          dob: e as unknown as string,
                        })
                      }
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        color: 'white',
                        backgroundColor: 'transparent',
                        width: '100%',
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      // backgroundColor: 'pink',
                    }}
                  >
                    <BoldLabelFormItem style={{ width: '80%' }}>
                      {errmessage && (
                        <Alert
                          message={errmessage}
                          type="error"
                          style={{
                            marginBottom: 16,
                            border: 'none',
                          }}
                        />
                      )}
                      <Button
                        block
                        type="primary"
                        loading={isLoading}
                        disabled={!isValid}
                        size="large"
                        htmlType="submit"
                        // onClick={() => navigate('/connectLifeOtp')}
                      >
                        {t('common.submit')}
                      </Button>
                    </BoldLabelFormItem>
                    {/* <Link
                      style={{
                        fontWeight: 'normal',
                        marginLeft: 4,
                        marginRight: 4,
                        color: '#C21B17',
                        textDecoration: 'underline',
                      }}
                      to="/forgot/login"
                      onClick={(e) => e.preventDefault()}
                    >
                      {t('forgetLoginId.help')}
                    </Link> */}
                  </div>
                </Col>
              </FormWrapper>
            </Form>
          </Row>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default ProfileConnectLife;
